import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

type Props = {
  title?: string;
  subtitle?: React.ReactNode;
};

const KeyInformationItem = ({ title, subtitle }: Props) => {
  return (
    <div>
      <Typography variant="h2semibold">{title}</Typography>
      <Typography2 variant="bodySecondary" component="div" color="supportText">
        {subtitle}
      </Typography2>
    </div>
  );
};

export default KeyInformationItem;
